import React from "react";

import Button from "components/Button";

import { Wrapper, Title, Location } from "./styles";

const Job = ({ content }) => {
  return (
    <Wrapper
      target="_blank"
      href={content.absolute_url}
      rel="noopener noreferrer"
    >
      <Title>{content.title}</Title>
      <Location>{content.location.name}</Location>
      <Button size="small" mt="30px" px="20px">
        View Role
      </Button>
    </Wrapper>
  );
};

export default Job;
